import React from 'react'
import { TextField } from 'admin-on-rest'
import { getCurrentUserId } from '../helpers'

export const StudentGradeField = ({ record = {} }) => {
  return <span>{record.grades[getCurrentUserId()] || '-'}</span>
}



// WEBPACK FOOTER //
// ./src/components/StudentGradeField.js